import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextInput, Checkbox } from 'react-orange-ui';

class InputCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      canBlur: true,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { checked } = this.state;

    if (prevState.checked !== checked) {
      this.activateBlur();
    }
  }

  handleCheck = (e) => {
    const { onCheck } = this.props;

    this.setState({
      checked: e.checked,
    });
    onCheck(e.checked);
  };

  handleMouseDown = () => {
    this.setState({ canBlur: false });
  };

  handleBlur = (e) => {
    const { checked, canBlur } = this.state;
    const { onBlur } = this.props;

    if (!checked && canBlur) {
      onBlur(e);
    }
  };

  activateBlur = () => {
    const { canBlur } = this.state;

    if (!canBlur) {
      this.setState({ canBlur: true });
    }
  };

  render() {
    const { checked } = this.state;
    const {
      id, radioLabel, maxLength, label, value, onChange, errorMessage, valid,
    } = this.props;

    return (
      <div>
        <TextInput
          id={id}
          valid={valid}
          errorMessage={errorMessage}
          value={value}
          disabled={checked}
          onChange={onChange}
          onBlur={this.handleBlur}
          maxLength={maxLength}
        >
          {label}
        </TextInput>
        <Checkbox id={`checkbox__${id}`} onChange={this.handleCheck} onMouseDown={this.handleMouseDown} checked={checked}>
          {radioLabel}
        </Checkbox>
      </div>
    );
  }
}

InputCheckbox.defaultProps = {
  onChange: undefined,
  onCheck: undefined,
  onBlur: undefined,
  maxLength: 254,
  errorMessage: '',
  valid: true,
};

InputCheckbox.propTypes = {
  /** String input identifier */
  id: PropTypes.string.isRequired,
  /** String input value */
  value: PropTypes.string.isRequired,
  /** String input label */
  label: PropTypes.string.isRequired,
  /** String label of the checkbox button */
  radioLabel: PropTypes.string.isRequired,
  /** Function executed on check */
  onCheck: PropTypes.func,
  /** Function executed when input changed */
  onChange: PropTypes.func,
  /** Function executed when input is blurred */
  onBlur: PropTypes.func,
  /** Number max length */
  maxLength: PropTypes.oneOf([15, 254]),
  /** String input error message */
  errorMessage: PropTypes.string,
  /** Boolean input error */
  valid: PropTypes.bool,
};

export default InputCheckbox;
